<template>
    <list-group-item :action="clickAction" color="primary">
        <i class="fas fa-door-open"></i> <strong>{{ pendingInspectionReports }} Pending Post Inspection {{ pluralize(pendingInspectionReports, 'Reports', 'Report') }}</strong>
    </list-group-item>
</template>

<script type="text/javascript">
    import UIComponents from '@/components/UI/index.vue';
    import Formatter from '@/classes/Formatter.js';

    export default {
        components: {
            ...UIComponents,
        },

        emits: ['click'],

        props: {
            pendingInspectionReports: {
                type: Number,
                required: true,
            }
        },

        methods: {
            clickAction() {
                this.$emit('click');
                this.$router.push('/owners/maintenance/issues/check-out');
            },

            pluralize(count, plural, single) {
                return Formatter.pluralize(count, plural, single);
            }
        },
    }
</script>